import { useMetaSchema } from "../useMetaSchema";
import { Options, createColum } from "./createColumn";

export function useColumn<T = any>(key: string, options: Options<T> = {}) {
  const schemaObj = useMetaSchema();

  return createColum(key, options, schemaObj);
}
